import { useEffect, useRef } from 'react';

/** 10-03 idle handling: re-prompt PIN after 15 minutes without discarding the token. */
export const FLOOR_IDLE_MS = Number(import.meta.env.VITE_MERCHANT_FLOOR_IDLE_MS || 15 * 60 * 1000);

/** Fire callback after floor inactivity (PIN modal / lock). */
export function useFloorIdleTimeout(enabled = true, onIdle?: () => void): void {
  const timer = useRef<number | null>(null);
  const onIdleRef = useRef(onIdle);
  onIdleRef.current = onIdle;

  useEffect(() => {
    if (!enabled) return;

    const reset = () => {
      if (timer.current) window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => {
        onIdleRef.current?.();
      }, FLOOR_IDLE_MS);
    };

    const events = ['pointerdown', 'keydown', 'touchstart', 'mousemove'] as const;
    events.forEach((ev) => window.addEventListener(ev, reset, { passive: true }));
    reset();

    return () => {
      if (timer.current) window.clearTimeout(timer.current);
      events.forEach((ev) => window.removeEventListener(ev, reset));
    };
  }, [enabled]);
}
